import {
  OverlayHoverDarkenStyle,
  OverlayPressedDarkenStyle,
} from "App/global-style";
import styled, { css } from "styled-components";

import Surface from "@storeblocks/surface";

export const ResultListbox = styled.ul`
  :focus {
    outline: none;
  }

  :focus-visible {
    li.active {
      outline: auto;
      ${OverlayHoverDarkenStyle}
    }
  }
`;

interface ResultCardProps {
  selectable: boolean;
}

export const ResultCard = styled(Surface)<ResultCardProps>`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 8px;
  max-width: 375px;
  padding: ${({ theme }) => theme.spacing.sm};
  position: relative;

  :hover {
    cursor: pointer;
    ${OverlayHoverDarkenStyle}
  }

  :focus {
    ${OverlayHoverDarkenStyle}
  }

  :active {
    ${OverlayPressedDarkenStyle}
  }

  ${({ selectable }) => selectable && RadioStyle}
`;

const RadioStyle = css`
  &::before {
    background-color: ${({ theme }) => theme.brandColors.white};
    border: 2px solid ${({ theme }) => theme.brandColors.black};
    border-radius: 50%;
    box-sizing: border-box;
    content: "";
    flex-shrink: 0;
    height: ${({ theme }) => theme.spacing.sm};
    margin-right: ${({ theme }) => theme.spacing.sm};
    margin-top: 5px;
    width: ${({ theme }) => theme.spacing.sm};
  }
`;
